import React, { useState, useRef } from "react";
import Editor from '@monaco-editor/react';

const IDE = () => {
    const [code, setCode] = useState(`var a = '';

let i = 0;

for(i; i<5; i++){
  a += '*';
  console.log(a)
}`);
    const [output, setOutput] = useState('');
    const [language, setLanguage] = useState('javascript');
    const editorRef = useRef(null);

    const runCode = () => {
        const originalConsoleLog = console.log;
        const originalConsoleError = console.error;

        console.log = (...args) => {
            setOutput(prevOutput => prevOutput + args.join(' ') + '\n');
            originalConsoleLog(...args);
        };
        console.error = (...args) => {
            setOutput(prevOutput => prevOutput + args.join(' ') + '\n');
            originalConsoleError(...args);
        };

        try {
            setOutput('');
            if (language === 'javascript') {
                eval(code);
            } else {
                setOutput(`Execution for ${language} not implemented.`);
            }
        } catch (error) {
            setOutput(error.toString());
        }

        console.log = originalConsoleLog;
        console.error = originalConsoleError;
    };

    const handleEditorChange = (value) => {
        setCode(value);
    };

    const handleLanguageChange = (event) => {
        setLanguage(event.target.value);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-[#05050a] via-[#0b0b13] to-[#13131a] flex flex-col items-center py-8 px-2">
            <div className="w-full max-w-5xl bg-[#0b0b13] rounded-xl shadow-2xl flex flex-col gap-4 p-6"
                style={{
                    border: '2px solid #00ffc3',
                    boxShadow: '0 0 8px 1px #00ffc3, 0 0 20px 2px #00e0ff'
                }}>
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <select
                        value={language}
                        onChange={handleLanguageChange}
                        className="font-bold p-2 outline-none border rounded-lg bg-[#13131a] text-white transition focus:ring-2"
                        style={{
                            border: '2px solid #00ffc3',
                            boxShadow: '0 0 4px #00ffc3'
                        }}
                    >
                        <option value='javascript'>JavaScript</option>
                    </select>
                    <button
                        className="px-6 py-2 font-bold rounded-lg text-white shadow transition"
                        style={{
                            background: '#13131a',
                            border: '2px solid #00ffc3',
                            boxShadow: '0 0 6px #00ffc3, 0 0 12px #00e0ff'
                        }}
                        onClick={runCode}
                    >
                        Run Code <i className="fa-solid fa-arrow-right ml-2"></i>
                    </button>
                </div>
                <div className="flex flex-col md:flex-row gap-4">
                    <div
                        className="flex-1 rounded-lg overflow-hidden shadow p-2"
                        style={{
                            border: '2px solid #00ffc3',
                            boxShadow: '0 0 6px #00ffc3'
                        }}
                    >
                        <Editor
                            height="60vh"
                            width="100%"
                            language={language}
                            value={code}
                            onChange={handleEditorChange}
                            theme="vs-dark"
                            editorDidMount={(editor) => (editorRef.current = editor)}
                        />
                    </div>
                    <div
                        className="md:w-1/3 w-full rounded-lg shadow p-4 overflow-y-auto max-h-[60vh]"
                        style={{
                            background: '#13131a',
                            border: '2px solid #00ffc3',
                            boxShadow: '0 0 6px #00ffc3'
                        }}
                    >
                        <h2 className="text-[#00ffc3] font-bold mb-2 text-lg">Output</h2>
                        <pre className="whitespace-pre-wrap text-gray-200 text-sm">{output}</pre>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IDE;